/**
 * How light a colour is, the WCAG way.
 *
 * Used where something has to stay readable on a garment of any colour: the
 * default text colour and the selection border in Direct Sale.
 */

/** Below this, white reads better on the colour than near-black does. */
export const DARK_LUMINANCE_THRESHOLD = 0.18;

/** WCAG relative luminance (0 black – 1 white) of a #rgb/#rrggbb colour; null if it is neither. */
export function relativeLuminance(color?: string | null): number | null {
  const hex = color?.trim().replace('#', '') ?? '';
  const full =
    hex.length === 3
      ? [...hex].map((ch) => ch + ch).join('')
      : hex.length === 6
        ? hex
        : null;
  if (!full || /[^0-9a-f]/i.test(full)) return null;

  const linear = (offset: number) => {
    const channel = parseInt(full.slice(offset, offset + 2), 16) / 255;
    return channel <= 0.03928
      ? channel / 12.92
      : ((channel + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * linear(0) + 0.7152 * linear(2) + 0.0722 * linear(4);
}

/** Unknown colours count as light — the catalogue's fallback is white. */
export function isDarkColor(color?: string | null): boolean {
  const luminance = relativeLuminance(color);
  return luminance !== null && luminance < DARK_LUMINANCE_THRESHOLD;
}
